import { BdsGrid, BdsIllustration, BdsTypo } from 'blip-ds/dist/blip-ds-react/components';
import './EmptyContainer.scss';
import { EmptyContainer as EmptyContainerProps } from '../../interfaces';

export const EmptyContainer = ({ title, subtitle, subtitleItem }: EmptyContainerProps) => {
  return (
    <BdsGrid direction="column" justifyContent="center" alignItems="center" margin='t-6' gap="2" class="empty_screen">
      <BdsIllustration class="modal_illustration" name="empty" type="spots" />
      <BdsTypo variant="fs-24" class='color-content-disabled' bold='bold' lineHeight='small'>
        {title}
      </BdsTypo>
      <BdsTypo variant="fs-16" class='color-content-disabled' lineHeight='simple'>
        {subtitle}
      </BdsTypo>
      <BdsTypo variant="fs-16" class='color-content-disabled' lineHeight='none'>
        {subtitleItem}
      </BdsTypo>
    </BdsGrid>
  );
};
